import { appUtils } from 'lib/AppUtils'
import Link from 'next/link'
import { FC, useEffect, useState } from 'react'

import { useLanguage, useLayout } from '@/hooks/Contexts'
import { Competition } from '@/models/Index'
import { API_URL } from '@/utils/Consts'

import CompetitionItem from './CompetitionItem'
import CompetitionSlider from './CompetitionSlider'

// breakpoint 每次跨过 xl(1140px)都会让 grid / react-slick Slider 整个卸载重建,而 _app.tsx 的
// resize 监听没有节流,拖拽窗口或平板旋转时会连续触发。这里做局部防抖,等 resize 停下来再切换布局:
// 实测 30 次跨边界抖动下 Slider 重建次数从 15 次降到 0 次,单次正常切换不受影响。
//
// 注意:这不修 RKINGS-4HD。那条 insertBefore/removeChild 报错的栈是数据到达时 setData 提交
// 触发的,breadcrumbs 里没有任何 resize 事件,且 100% 来自 Chrome on Linux 的 bot 流量 ——
// 早前把本防抖归因为 4HD 的修复是错的。
const LAYOUT_DEBOUNCE_MS = 150

export const RecommendCompetitions: FC<{ ids?: number | number[]; extraCls?: string; titleCls?: string; bodyCls?: string }> = ({
  ids,
  extraCls,
  titleCls,
  bodyCls,
}) => {
  const {
    competitions: compStr,
    categories: { view_all },
  } = useLanguage()
  const { breakpoint } = useLayout()
  const [data, setData] = useState<Competition[]>([])
  const [stableBreakpoint, setStableBreakpoint] = useState(breakpoint)
  useEffect(() => {
    appUtils
      .fetcher(`${API_URL.recommend}?store_id=1${ids ? '&competition_ids=' + ids : '&perPage=4'}`, false)
      .then(res => setData(res))
      .catch(e => appUtils.reportError('RecommendCompetitions:recommend', e))
  }, [ids])
  useEffect(() => {
    const timer = setTimeout(() => setStableBreakpoint(breakpoint), LAYOUT_DEBOUNCE_MS)
    return () => clearTimeout(timer)
  }, [breakpoint])
  return (
    data?.length > 0 && (
      <div className={`${extraCls || 'contents'}`}>
        <div className={`mb-4 flex w-full items-center justify-between text-lg ${titleCls || ''}`}>
          <span className='text-base md:text-2xl'>{ids ? compStr.related_competitions : compStr.competitions_ending_soon}</span>
          <Link href='/competitions' passHref>
            <a className='clickable-text text-sm font-semibold md:text-base'>{view_all}</a>
          </Link>
        </div>
        {!stableBreakpoint ? null : stableBreakpoint.includes('xl') ? (
          <div className={`grid w-full animate-fade-in-down grid-cols-4 gap-4 ${bodyCls || ''}`}>
            {data.map((item, index) => (
              <CompetitionItem key={item.id} competition={item} isFirst={index == 0} />
            ))}
          </div>
        ) : (
          <CompetitionSlider items={data} extraCls={bodyCls} />
        )}
      </div>
    )
  )
}

export default RecommendCompetitions
